import backgroundLeft from '../../../img/backgroundLeft.png';
import backgroundRight from '../../../img/backgroundRight.png';

//Familia

//Container
export const backgroundContainer = `url(${backgroundLeft}) no-repeat left,
 		url(${backgroundRight}) no-repeat bottom right`;
